/* STILL 18.10 · scratch card: the code after the e-mail address.
   Loaded by sections/nocta-v8-scratch.liquid when "Show the code only after the e-mail address" is on.
   nocta-v8.js still runs the card (foil, scratching, opening, closing, swipe down). This file only:
   1. once the foil is off (the card gets "is-revealed"), puts the e-mail field where the copy button was;
   2. sends the address to Shopify as a newsletter sign-up (form 'customer', tags in the section), with
      Shopify's spam protection (hCaptcha) on: the page stays, nothing reloads;
   3. then turns the dots under the foil into the code and wakes the copy button (copying is done here,
      as nocta-v8.js does it, because the page itself never holds the code as text).
   If Shopify asks for a captcha page (rare), the form is sent the normal way; back on the page the card
   opens again with the code. A visitor who already signed up here gets the code right after scratching.
   In the theme editor nothing is sent: the button shows the next step. */
(function () {
  'use strict';
  var host = document.querySelector('[data-nocta="scratch"]');
  var cfgEl = host && host.querySelector('script[data-nx-scm-cfg]');
  if (!cfgEl || host.__nxScm) return;
  host.__nxScm = true;

  var C = {}, S = {};
  try { C = JSON.parse(cfgEl.textContent) || {}; } catch (e) { return; }
  try { S = JSON.parse(host.querySelector('script[data-nx-config]').textContent) || {}; } catch (e) {}
  var q = function (sel, root) { return (root || host).querySelector(sel); };
  var wrap = q('[data-nx-sc]'), card = wrap && q('[data-nx-sc-card]', wrap);
  var box = card && q('[data-nx-sc-mail]', card), form = box && q('form', box);
  if (!form) return;
  var input = q('input[type="email"]', form), msg = q('[data-nx-sc-mail-msg]', form), go = q('[data-nx-sc-mail-go]', form);
  var actions = q('[data-nx-sc-actions]', card), copyBtn = q('[data-nx-sc-copy]', card);
  var copyT = q('[data-nx-sc-copy-t]', card) || copyBtn;
  var codeEl = q('[data-nx-sc-code]', card), fine = q('.nx-sc-fine', card), live = q('[data-nx-sc-live]', card);
  var foil = q('[data-nx-sc-foil]', card), prize = q('[data-nx-sc-prize]', card);
  var code = '';
  try { code = atob(C.k || ''); } catch (e) {}
  if (!code || !input || !go || !actions || !copyBtn) return;

  var DONE = 'nx-scm-done', PEND = 'nx-scm-pending';
  var rx = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var done = false, sending = false, pass = false, spinT = 0, hc = null;
  var store = function (k, v, ses) { try { var st = ses ? sessionStorage : localStorage; if (v == null) st.removeItem(k); else st.setItem(k, v); } catch (e) {} };
  var read = function (k, ses) { try { return (ses ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } };
  var design = function () { return !!(window.Shopify && window.Shopify.designMode); };
  var say = function (t) { if (!live) return; live.textContent = ''; requestAnimationFrame(function () { live.textContent = t; }); };
  var focus = function (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } };
  if (read(DONE) === '1') done = true;

  form.setAttribute('novalidate', '');
  // the card can be swiped down on phones; a tap in the field must stay a tap in the field
  box.addEventListener('pointerdown', function (e) { e.stopPropagation(); });

  /* ---------- the e-mail step, once the foil is off ---------- */
  function disclaimer(on) {
    // Shopify's hCaptcha shows its own floating badge unless the page names it: named here, under the field
    if (on && !hc && !document.querySelector('p[data-spam-detection-disclaimer]')) {
      hc = document.createElement('p');
      hc.className = 'nx-sc-mail-hc';
      hc.setAttribute('data-spam-detection-disclaimer', '');
      hc.appendChild(document.createTextNode((C.captcha || 'Az űrlapot a hCaptcha védi.') + ' '));
      [['https://www.hcaptcha.com/privacy', 'Adatvédelem'], ['https://www.hcaptcha.com/terms', 'Feltételek']].forEach(function (l, i) {
        if (i) hc.appendChild(document.createTextNode(' · '));
        var a = document.createElement('a');
        a.href = l[0]; a.target = '_blank'; a.rel = 'noopener'; a.textContent = l[1];
        hc.appendChild(a);
      });
      form.appendChild(hc);
    } else if (!on && hc) { hc.remove(); hc = null; }
  }
  var finePtr = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  function mailStep() {
    if (done) {
      if (codeEl.textContent !== code) { showCode(false); say(String(C.done || '').replace('[code]', code)); }
      return;
    }
    if (!box.hidden) return;
    var a = document.activeElement, kb = a === copyBtn || a === foil;
    actions.hidden = true;
    if (fine) fine.hidden = true;
    box.hidden = false;
    disclaimer(true);
    // a keyboard or a mouse: straight into the field; on touch screens the keyboard waits for a tap,
    // but Shopify's spam protection starts loading now, so the button answers at once
    if (kb || finePtr) focus(input);
    else input.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
  }
  function showCode(moveFocus) {
    if (codeEl.textContent !== code) {
      codeEl.textContent = code;
      codeEl.classList.remove('is-dots');
      codeEl.classList.add('is-in');
    }
    box.hidden = true;
    actions.hidden = false;
    copyBtn.disabled = false;
    copyBtn.removeAttribute('aria-describedby');
    if (fine) fine.hidden = false;
    if (moveFocus) focus(copyBtn);
  }
  new MutationObserver(function () {
    if (wrap.classList.contains('is-revealed')) mailStep();
    if (!wrap.classList.contains('is-on') && hc) disclaimer(false);
    else if (wrap.classList.contains('is-on') && !box.hidden) disclaimer(true);
  }).observe(wrap, { attributes: true, attributeFilter: ['class'] });

  /* ---------- sending ---------- */
  function spin(on) {
    clearTimeout(spinT);
    go.classList.toggle('is-busy', on);
    go.setAttribute('aria-busy', on ? 'true' : 'false');
    var sp = q('.nx-spin', go);
    if (on && !sp) { sp = document.createElement('i'); sp.className = 'nx-spin'; sp.setAttribute('aria-hidden', 'true'); go.appendChild(sp); }
    if (!on && sp) sp.remove();
    // the spam check can be closed without an answer: the button comes back after a while
    if (on) spinT = setTimeout(function () { if (!sending) spin(false); }, 30000);
  }
  function note(t, field) {
    msg.textContent = t || '';
    if (field) { input.setAttribute('aria-invalid', 'true'); focus(input); }
    else input.removeAttribute('aria-invalid');
  }
  function success() {
    sending = false;
    done = true;
    spin(false);
    store(DONE, '1');
    var had = box.contains(document.activeElement);
    note('');
    showCode(had);
    say(String(C.done || '').replace('[code]', code));
  }
  function fail(kind) {
    sending = false;
    spin(false);
    if (kind === 'bad') note(C.bad, true);
    else note(C.error, false);
  }
  // Shopify answered with its own captcha page: send the form the normal way (the page reloads there)
  function toPage() {
    store(PEND, '1', true);
    HTMLFormElement.prototype.submit.call(form);
  }
  function verdict(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var f = doc.getElementById(form.id);
    if (!f) return 'err';
    if (f.querySelector('[data-nx-scm-ok]')) return 'ok';
    var er = f.querySelector('[data-nx-scm-err]');
    if (!er) return 'err';
    if (/taken|already|már/i.test(er.getAttribute('data-m') || '')) return 'ok';      // signed up before: still the code
    return /\bemail\b/.test(er.getAttribute('data-f') || '') ? 'bad' : 'err';
  }
  function send() {
    if (sending || done) return;
    sending = true;
    spin(true);
    var body = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (typeof v === 'string') body.append(k, v); });
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 20000);
    fetch((form.getAttribute('action') || '/contact').split('#')[0], {
      method: 'POST', body: body, credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: ctl ? ctl.signal : undefined
    }).then(function (r) {
      var u = r.url || '';
      if (/[?&]customer_posted=true/.test(u)) { if (ctl) ctl.abort(); return 'ok'; }
      if (/\/challenge\b/.test(u)) { if (ctl) ctl.abort(); return 'challenge'; }
      return r.text().then(verdict);
    }).then(function (v) {
      clearTimeout(timer);
      if (v === 'ok') success();
      else if (v === 'challenge') toPage();
      else fail(v);
    }, function () {
      clearTimeout(timer);
      fail('err');
    });
  }
  // Shopify's spam protection takes the form's own submit() when it starts and calls it with its token:
  // this one sends in the background instead of leaving the page
  try { form.submit = send; } catch (e) {}

  // checked first (window, capture phase), so a wrong address never reaches the spam protection
  window.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    if (pass) { pass = false; return; }
    var v = input.value.trim();
    if (!rx.test(v)) { e.preventDefault(); e.stopImmediatePropagation(); note(v ? C.bad : C.empty, true); return; }
    input.value = v;
    note('');
    if (sending || done) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (design()) { e.preventDefault(); e.stopImmediatePropagation(); spin(true); setTimeout(function () { spin(false); done = true; showCode(true); }, 500); return; }
    spin(true);
    if (form.hasAttribute('data-hcaptcha-bound') || form.hasAttribute('data-recaptcha-bound')) return;   // Shopify takes it from here
    e.preventDefault(); e.stopImmediatePropagation();
    if (!form.hasAttribute('data-cptcha')) { send(); return; }     // no spam protection on this form
    // the spam protection starts when the field gets the focus and may still be loading: wait (at most 6 s)
    var t0 = Date.now();
    (function wait() {
      if (form.hasAttribute('data-hcaptcha-bound') || form.hasAttribute('data-recaptcha-bound')) {
        pass = true;
        if (form.requestSubmit) form.requestSubmit(go); else go.click();
        pass = false;
      } else if (Date.now() - t0 > 6000) send();
      else setTimeout(wait, 150);
    })();
  }, true);
  input.addEventListener('input', function () {
    if (input.getAttribute('aria-invalid') === 'true' && rx.test(input.value.trim())) note('');
  });

  /* ---------- copying (as in nocta-v8.js, with the code from here) ---------- */
  var copyT0 = null, copyTimer = 0;
  card.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-nx-sc-copy]')) return;
    e.stopPropagation();
    e.preventDefault();
    if (!done) return;
    var finish = function (ok) {
      if (copyT0 == null) copyT0 = copyT.textContent;
      copyT.textContent = ok ? (S.copied || 'Kimásolva ✓') : (S.copyFail || copyT0);
      copyBtn.classList.toggle('is-done', ok);
      if (!ok) {
        var r = document.createRange();
        r.selectNodeContents(codeEl);
        var sel = getSelection(); sel.removeAllRanges(); sel.addRange(r);
      }
      say(copyT.textContent);
      clearTimeout(copyTimer);
      copyTimer = setTimeout(function () { copyT.textContent = copyT0; copyBtn.classList.remove('is-done'); }, 2000);
    };
    var legacy = function () {
      var ok = false;
      try {
        var ta = document.createElement('textarea');
        ta.value = code; ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;left:0;top:0;opacity:0;font-size:16px';
        card.appendChild(ta); ta.select();
        ok = document.execCommand('copy');
        ta.remove(); focus(copyBtn);
      } catch (er) { ok = false; }
      finish(ok);
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(function () { finish(true); }, legacy);
    else legacy();
  }, true);

  /* ---------- back from Shopify's captcha page: the card again, with the code ---------- */
  if (read(PEND, true) === '1') {
    store(PEND, null, true);
    if (/[?&]customer_posted=true/.test(location.search)) {
      done = true;
      store(DONE, '1');
      var tries = 0;
      (function open() {
        var api = window.Still && window.Still.scratch;
        if (!api) { if (++tries < 80) setTimeout(open, 125); return; }
        api.show();
        wrap.classList.add('is-revealed');
        if (foil) foil.hidden = true;
        if (prize) prize.removeAttribute('aria-hidden');
        showCode(true);
        say(String(C.done || '').replace('[code]', code));
      })();
    }
  }
})();
